import { shortUserFromDto } from '@src/features/users/lib/user';

import type {
  ClientCompetition,
  ClientCompetitionDto,
  ClientContract,
  ClientContractDto,
  ClientGroupDeactivation,
  ClientGroupDeactivationDto,
  ClientGroupDetail,
  ClientGroupDetailDto,
} from '../types';
import { clientListItemFromDto, clientOptionFromDto } from './client';

export function clientContractFromDto(row: ClientContractDto): ClientContract {
  return {
    id: row.id,
    version: row.version,
    start: row.ccon_start,
    end: row.ccon_end,
    geographicArea: row.ccon_geographic_area,
    type: row.type,
    serviceAreaIds: row.service_areas,
  };
}

export function clientCompetitionFromDto(
  row: ClientCompetitionDto,
): ClientCompetition {
  return {
    id: row.id,
    version: row.version,
    start: row.comp_start,
    end: row.comp_end,
    geographicArea: row.comp_geographic_area,
    competitor: row.competitor,
    serviceAreaIds: row.service_areas,
  };
}

export function clientGroupDetailFromDto(
  group: ClientGroupDetailDto,
): ClientGroupDetail {
  const { headquarter } = group;
  return {
    id: group.id,
    version: group.version,
    name: group.clgr_name,
    estimatedRevenuePotential: group.clgr_estimated_revenue_potential,
    website: group.clgr_website,
    notes: group.clgr_notes,
    logo: group.logo,
    sector: group.sector,
    relationshipStatus: group.relationship_status,
    manager: shortUserFromDto(group.manager),
    coordinator: shortUserFromDto(group.coordinator),
    headquarter: headquarter && {
      id: headquarter.id,
      name: headquarter.name,
      legalName: headquarter.legal_name,
      businessSegment: headquarter.business_segment,
      active: headquarter.active,
    },
    verificationDate: group.verification_date,
    verifiedBy: group.verified_by && shortUserFromDto(group.verified_by),
    businessSegments: group.business_segments,
    active: group.active,
    revenueCurrentYear: group.revenue_current_year,
    revenuePreviousYear: group.revenue_previous_year,
    budgetFulfilment: group.budget_fulfilment,
    canEdit: group.can_edit,
    canActivate: group.can_activate,
    canChangeHeadquarter: group.can_change_headquarter,
    entities: group.entities.map(clientListItemFromDto),
    contracts: group.contracts.map(clientContractFromDto),
    competitions: group.competitions.map(clientCompetitionFromDto),
  };
}

export function clientGroupDeactivationFromDto(
  data: ClientGroupDeactivationDto,
): ClientGroupDeactivation {
  return {
    clients: data.clients.map(clientOptionFromDto),
    refusal: data.refusal,
  };
}
